import * as React from 'react';
import { usePersonAccountsTAccTwrrYRdt } from '../../hooks';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';

export const PersonsAccountsTAccTwrrYRdtYTDValue = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonAccountsTAccTwrrYRdt();
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={{
        style: 'percent',
      }}
    />
  );
};
